import { render } from "./AppArchiveProduct.vue?vue&type=template&id=38d47983&scoped=true"
import script from "./AppArchiveProduct.vue?vue&type=script&lang=js"
export * from "./AppArchiveProduct.vue?vue&type=script&lang=js"

import "./AppArchiveProduct.vue?vue&type=style&index=0&id=38d47983&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d47983"]])

export default __exports__